
import React from 'react';
import { Transaction } from '@/types/transaction';

interface TransactionCustomerInfoProps {
  transaction: Transaction;
  customerDisplay: string;
}

const TransactionCustomerInfo: React.FC<TransactionCustomerInfoProps> = ({ transaction, customerDisplay }) => {
  return (
    <div className="bg-[#F2F2F2] rounded-lg p-4">
      <h3 className="text-sm font-medium text-muted-foreground mb-1">Customer</h3>
      <p className="font-medium">{String(customerDisplay)}</p>
      {transaction.customerEmail && transaction.customerEmail !== customerDisplay && (
        <p className="text-sm text-muted-foreground mt-1 max-w-[200px] truncate">{transaction.customerEmail}</p>
      )}
    </div>
  );
};

export default TransactionCustomerInfo;
